import { getPropsFromParams } from '../utils.routing'
import MonthlyReport from '@/components/admin/MonthlyReport'
import { adminRouteNames } from '@/routing/routeNames/adminRouteNames'
import AdminDashboard from '@/components/admin/AdminDashboard'
import OrganizationReport from '@/components/admin/OrganizationReport'

export const AdminRoutes = [
  {
    path: '/admin-pages',
    name: adminRouteNames.monthlyReport,
    props: getPropsFromParams,
    component: AdminDashboard,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/admin-pages/monthly-report',
    name: adminRouteNames.monthlyReport,
    props: getPropsFromParams,
    component: MonthlyReport,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
  {
    path: '/admin-pages/:organizationSlug',
    name: adminRouteNames.organizationReport,
    component: OrganizationReport,
    meta: {
      requiresAuthentication: true,
      redirectIfAuthenticated: false,
    },
  },
]
